import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '“舞出健康 无限美好”线上全民健身舞蹈展示大赛';
const baseUrl = 'dancehealth20221213';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/home`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'home',
      name: `${baseUrl}-home`,
      component: () => import('./pages/Home.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'detail',
      name: `${baseUrl}-detail`,
      component: () => import('./pages/Detail.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'rule',
      name: `${baseUrl}-rule`,
      component: () => import('./pages/Rule.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'save',
      name: `${baseUrl}-save`,
      component: () => import('./pages/Save.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'setnum2022synewadmincenter',
      name: `${baseUrl}-setnum2022synewadmincenter`,
      component: () => import('./pages/Setnum.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
